import React from "react";
import { trackLoginSignupRedirectClicked } from "../../../../trackLoginEvents";
import { SIGNUP_URL } from "../constants";
import * as S from "../styles";

export default function LoginFooter(): React.ReactElement {
  return (
    <S.FooterText>
      Ainda não tem uma conta na Jusfy?{" "}
      <S.InlineLink href={SIGNUP_URL} onClick={trackLoginSignupRedirectClicked}>
        Cadastre-se.
      </S.InlineLink>
    </S.FooterText>
  );
}
